// What kind of machine a robot onboarding ran on. The onboard-agent builds
// it from discover's probes and returns it in `propose` as `plan.robotProfile`;
// the Cortex agent passes it as `robotProfile` to save_approved_robot_plan.
// Input is lenient on purpose: a profile must never block recording an
// approval, so missing optional facts become null (or [] / false) and an
// unknown category becomes `other`. The parsed (output) type is the contract.
import { z } from 'zod';
export const RobotDeviceCategorySchema = z.enum([
    'quadruped',
    'wheeled',
    'arm',
    'drone',
    'humanoid',
    'computer',
    'other',
]);
const optionalText = z.string().nullable().default(null);
export const RobotProfileRosSchema = z.object({
    version: z.union([z.literal(1), z.literal(2)]),
    distro: z.string(),
    rmw: optionalText,
    inContainer: z.boolean().default(false),
});
export const RobotProfileSchema = z.object({
    /** Human label, e.g. "Boston Dynamics Spot", "TurtleBot 3", "Raspberry Pi 5", "Linux PC". */
    deviceType: z.string().trim().min(1).max(120),
    deviceCategory: RobotDeviceCategorySchema.catch('other'),
    /** A simulator (Gazebo, Isaac, …) was detected rather than real hardware. */
    simulated: z.boolean().default(false),
    /** /proc/device-tree/model, or DMI sys_vendor + product_name. */
    hardwareModel: optionalText,
    /** /etc/os-release NAME, e.g. "Ubuntu". */
    os: z.string().default('unknown'),
    /** /etc/os-release VERSION_ID, e.g. "22.04". */
    osVersion: optionalText,
    /** Userland `uname -m`: x86_64, aarch64, armv7l. */
    arch: z.string().default('unknown'),
    kernel: optionalText,
    glibc: optionalText,
    ros: RobotProfileRosSchema.nullable().default(null),
    pythonVersion: optionalText,
    /** Vendor SDKs python3 imports, e.g. ["bosdyn"], ["unitree_sdk2py"]. */
    vendorSdks: z.array(z.string()).default([]),
    /** onboard-agent version that built the profile. */
    agentVersion: z.string().default('unknown'),
});
/** Label used when nothing identifies the device. */
export const unknownDeviceType = 'Unknown';
//# sourceMappingURL=robot-profile.js.map